import React from 'react';
import {
  NavLink,
} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { useTranslation } from 'react-i18next';

// style
// import { globalStyle } from '../../global/style';
import './style.scss';
import '../../global/styles.scss';
import './styles.css';
import { styles } from './style';

// images
import Th from '../../assets/fag/th.png';
import En from '../../assets/fag/en.png';
import { Hidden } from '@material-ui/core';

const initPath = `/${process.env.REACT_APP_PATH}`;

const useStyles = makeStyles(styles);

export default function Header() {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const currentTH = i18n.language === 'th';
  const currentEN = i18n.language === 'en';

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <Box>
        <NavLink to={`${initPath}`} className="navbar-item">
          {t('ภาพรวมประเทศไทย')}
        </NavLink>
        <NavLink to={`${initPath}intro`} activeClassName="navbar-active" className="navbar-item">
          {t('แนะนำการใช้งาน')}
        </NavLink>
        <NavLink to={`${initPath}about`} activeClassName="navbar-active" className="navbar-item">
          {t('เกี่ยวกับเรา')}
        </NavLink>
        <NavLink to={`${initPath}contact`} activeClassName="navbar-active" className="navbar-item">
          {t('ติดต่อเรา')}
        </NavLink>
      </Box>
      <Divider />
      <Hidden mdUp>
        <Box mt={2}>
          <Typography noWrap variant="caption">
            {t('เปลี่ยนภาษา')}
          </Typography>
          {currentTH && (
            <MenuItem style={{ paddingLeft: 0 }} onClick={() => changeLanguage('en')}>
              <ListItemIcon>
                <img src={En} alt="En" />
              </ListItemIcon>
              <Typography className={classes.lang} noWrap>
                En
              </Typography>
            </MenuItem>
          )}

          {currentEN && (
            <MenuItem style={{ paddingLeft: 0 }} onClick={() => changeLanguage('th')}>
              <ListItemIcon>
                <img src={Th} alt="Th" />
              </ListItemIcon>
              <Typography className={classes.lang} noWrap>
                ไทย
              </Typography>
            </MenuItem>
          )}
        </Box>
      </Hidden>
    </>
  );
}
